import LessonViewer from '../components/LessonViewer';
import { geometryLessons } from './lessons';

export default function GeometryFreeLessons() {
  return (
    <LessonViewer
      courseTitle="Geometry"
      courseDescription="Master angles, triangles, and the Pythagorean theorem with detailed explanations and practice"
      topicGroups={geometryLessons}
      previousCourse={{ name: 'Algebra 1', path: '/free-lessons/algebra1' }}
      nextCourse={{ name: 'Algebra 2', path: '/free-lessons/algebra2' }}
    />
  );
}